import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseButtonComponent } from '../base-button';
import { Action, ActionType } from 'src/app/models/action';

@Component({
  selector: 'app-follow-button',
  templateUrl: './follow-button.component.html',
  styleUrls: ['./follow-button.component.scss', '../base-button.scss'],
})
export class FollowButtonComponent extends BaseButtonComponent {
  @Input()
  isMoreOption: string;

  @Input()
  recordIcon: string;

  @Input()
  recordId: string;

  @Output()
  disableRecord: EventEmitter<boolean> = new EventEmitter<boolean>();

  isFollower = false;

  ngOnInit() {
    if (this.recordId != null) {
      this.record = { id: this.recordId };
    }

    if (
      this.authService.isAuthenticated() &&
      this.record.wishListInfo.followers.find((f) => `${Number(this.userService.getUserId())}` === f)
    ) {
      this.isFollower = true;
    }
  }

  doFollow() {
    const action: Action = {
      type: ActionType.FOLLOW,
      recordId: this.record.id,
    };

    this.doAction(() => {
      // TODO
      if (this.isFollower) {
        this.userService
          .unfollowListById(this.record.wishListInfo.id, this.record.title)
          .subscribe((_) => this.refreshUnfollow());
      } else {
        this.userService.followListById(this.record.wishListInfo.id).subscribe((_) => this.refreshFollow());
      }
    }, action);
  }

  private refreshFollow() {
    this.record.wishListInfo.followers.push(`${Number(this.userService.getUserId())}`);
    this.isFollower = true;
    this.waiting = false;
  }

  private refreshUnfollow() {
    const index = this.record.wishListInfo.followers.indexOf(`${Number(this.userService.getUserId())}`);
    if (index != -1) {
      this.record.wishListInfo.followers.splice(index, 1);
    }
    this.isFollower = false;
    this.waiting = false;
  }
}
